import React, { useState, useEffect } from 'react';
import { EAllowedDateDirection, IDateRangeProps } from './types';
import { Calendar } from './Calendar';

const today = new Date();
today.setHours(0, 0, 0, 0);

export const DateRange: React.FC<IDateRangeProps> = ({
	allowedDateDirection = EAllowedDateDirection.ALL,
	startDate,
	endDate,
	setStartDate,
	setEndDate,
}) => {
	const [displayMonth1, setDisplayMonth1] = useState(() => {
		// Initial calculation (runs once on mount)
		const initialDate = startDate ? new Date(startDate) : new Date();
		initialDate.setDate(1);
		initialDate.setHours(0, 0, 0, 0);
		return initialDate;
	});
	const [displayMonth2, setDisplayMonth2] = useState(() => {
		// Initial calculation (runs once on mount)
		const date = new Date(displayMonth1.getFullYear(), displayMonth1.getMonth() + 1, 1);
		date.setHours(0, 0, 0, 0);
		return date;
	});
	console.log('==========DateRange: displayMonth1', displayMonth1);
	console.log('==========DateRange: displayMonth2', displayMonth2);

	// Effect to update displayed months when startDate prop changes
	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => {
		const baseDate = startDate ? new Date(startDate) : new Date();
		baseDate.setDate(1);
		baseDate.setHours(0, 0, 0, 0);

		const nextMonthDate = new Date(baseDate.getFullYear(), baseDate.getMonth() + 1, 1);
		nextMonthDate.setHours(0, 0, 0, 0);

		// Only update state if the calculated month is different from the current state
		// Check against baseDate, not displayMonth1 to avoid infinite loops if initial state is the same
		if (displayMonth1.getTime() !== baseDate.getTime()) {
			setDisplayMonth1(baseDate);
		}
		// Check against nextMonthDate, not displayMonth2
		if (displayMonth2.getTime() !== nextMonthDate.getTime()) {
			setDisplayMonth2(nextMonthDate);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [startDate]); // Only depend on startDate

	const handleDateSelect = (date: Date) => {
		const selectedTime = date.getTime();

		if (allowedDateDirection === EAllowedDateDirection.PAST && selectedTime >= today.getTime()) {
			return;
		}
		if (allowedDateDirection === EAllowedDateDirection.FUTURE && selectedTime <= today.getTime()) {
			return;
		}

		if (!startDate || (startDate && endDate)) {
			setStartDate(date);
			setEndDate(null);
		} else if (startDate && !endDate) {
			const startTime = startDate.getTime();
			if (selectedTime >= startTime) {
				setEndDate(date);
			} else {
				setStartDate(date);
				setEndDate(null);
			}
		}
	};

	const handleMonthChange1 = (newDate: Date) => {
		newDate.setHours(0, 0, 0, 0);
		setDisplayMonth1(newDate);
		const nextMonth = new Date(newDate.getFullYear(), newDate.getMonth() + 1, 1);
		nextMonth.setHours(0, 0, 0, 0);
		// Always set the second month to be the one after the first one
		setDisplayMonth2(nextMonth);
	};

	const handleMonthChange2 = (newDate: Date) => {
		newDate.setHours(0, 0, 0, 0);
		const prevMonth = new Date(newDate.getFullYear(), newDate.getMonth() - 1, 1);
		prevMonth.setHours(0, 0, 0, 0);
		// Always set the first month to be the one before the second one
		setDisplayMonth1(prevMonth);
		setDisplayMonth2(newDate);
	};

	return (
		<div>
			{/* <h2 style={{ fontSize: '18px', fontWeight: 'bold', color: '#006293' }}>Select Period:</h2> */}
			<div style={{ display: 'flex', gap: '20px' }}>
				<Calendar
					displayDate={displayMonth1}
					startDate={startDate}
					endDate={endDate}
					onDateSelect={handleDateSelect}
					onMonthChange={handleMonthChange1}
					allowedDateDirection={allowedDateDirection}
					side="left"
				/>
				<Calendar
					displayDate={displayMonth2}
					startDate={startDate}
					endDate={endDate}
					onDateSelect={handleDateSelect}
					onMonthChange={handleMonthChange2}
					allowedDateDirection={allowedDateDirection}
					side="right"
				/>
			</div>
			{/* <div>
				<p>Start: {startDate ? startDate.toLocaleDateString('en-CA') : 'Not selected'}</p>
				<p>End: {endDate ? endDate.toLocaleDateString('en-CA') : 'Not selected'}</p>
			</div> */}
		</div>
	);
};
